import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./header.css";
import call from "../../assets/icons/call-answer-01.png";
import whatsapp from "../../assets/icons/WhatsApp.svg.png";
import map from "../../assets/icons/map.png";
import banner1 from "../../interior_assets/header-image/banner-1.jpeg";
import banner3 from "../../interior_assets/header-image/banner-7.jpeg";
import banner4 from "../../interior_assets/header-image/banner-3.jpeg";
import banner5 from "../../interior_assets/header-image/banner-4.jpeg";
import banner6 from "../../interior_assets/header-image/banner-5.jpeg";
import { useNavigate } from "react-router";
import ReCAPTCHA from "react-google-recaptcha";

function Header() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    
  });

  const [errors, setErrors] = useState({});
  const [responseMessage, setResponseMessage] = useState("");
   const [captchaVerified, setCaptchaVerified] = useState(false);
     const [loading, setLoading] = useState(false);
  
     
      
      const handleCaptchaChange = (value) => {
          if (value) {
            setCaptchaVerified(true); // Set to true when CAPTCHA is verified
          } else {
            setCaptchaVerified(false); // Set to false if not verified
          }
        };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    if (!captchaVerified) {
      setErrors("Please verify that you are not a robot.");
      return;
    }
    setLoading(true); // Start loading

    try {
      const response = await fetch("https://demo.firstskyinfra.in/php/model.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: formData.name,
          email: formData.email,
          phone: formData.phone,
          
          message: formData.message,
        }),
      });

      const result = await response.json();
      // setResponseMessage(result.message);

      if (response.ok) {
       navigate('/thank_you')
        setFormData({ name: "", email: "", phone: "", message: "" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      // alert("Something went wrong. Please try again.");
    }finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <>
    <header className="header-section">
      <Swiper modules={[Autoplay, Navigation, Pagination]} autoplay={{ delay: 3000, disableOnInteraction: false }} navigation pagination={{ clickable: true }} loop={true} className="banner-swiper">
        <SwiperSlide>
          <div className="banner" style={{ backgroundImage: `url(${banner1})` }}></div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="banner" style={{ backgroundImage: `url(${banner6})` }}></div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="banner" style={{ backgroundImage: `url(${banner3})` }}></div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="banner" style={{ backgroundImage: `url(${banner4})` }}></div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="banner" style={{ backgroundImage: `url(${banner5})` }}></div>
        </SwiperSlide>
      </Swiper>

      <div className="enquiry-box">
        <h2>Get In Touch</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
          {/* {errors.name && <p className="error">{errors.name}</p>} */}

          <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required/>
          {/* {errors.email && <p className="error">{errors.email}</p>} */}

          <input type="tel" name="phone" placeholder="Your Phone" value={formData.phone} onChange={handleChange} required/>
          {errors.phone && <p className="error">{errors.phone}</p>}

          <input type="text" name="message" placeholder="Your Message" value={formData.message} onChange={handleChange} required />

          <ReCAPTCHA
                                            sitekey='6LeiptIqAAAAAKT6diIfDS8Wu3vU-4SEIYxA0yB3'
                                                // sitekey="6LcwRb4qAAAAAMq-olseDFdPgiJ4s48v3oLdfMIW"
                                                // sitekey="6LdyK74qAAAAAHior1ETtBZRJf6-78AZFgkPYKf3"
                                                //  // Replace with your reCAPTCHA site key
                                                onChange={handleCaptchaChange}
                                            />

          <button type="submit" className="header-submit" disabled={loading}>
          {loading ? "Sending..." : "Submit"}
          </button>
        </form>
        {responseMessage && <p className="response-message">{responseMessage}</p>}
      </div>
    </header>

    <section>
    
            <div className="main-icons">
              <ul className="first">
                <li className="color1">
                  <a href="tel:+919500167678">
                    <p>Call <br />+91 9500167678</p>
                    <img src={call} width="20px" height="20px" className="img-fluid" />
                  </a>
                </li>
                <li className="color2">
                  <a href="https://api.whatsapp.com/send?phone=919500167678" target="_blank">
                    <p>Whatsapp <br />+91 9500167678</p>
                    <img src={whatsapp} width="24" height="24" className="img-fluid" />
                  </a>
                </li>
                {/* <li className="color3">
                  <a
                    href="https://maps.app.goo.gl/W9jNi6VWGbfWmbB57"
                    target="_blank"
                    rel="noopener noreferrer" 
                  >
                    <p style={{ color: "black" }}>Location <br />First Sky Infra</p>
                    <img src={map} width="30" height="30" className="img-fluid1" alt="Map Icon" />
                  </a>
                </li> */}
    
              </ul>
            </div>
          </section>


    </>
  );
}

export default Header;
